import PropTypes from 'prop-types';
import React from 'react';
import { useTimer } from '../../hooks';
import { Box } from '../Layout';
import { StrongText } from '../Typography';
export const TagOnlyLeft = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(Box, {
    borderRadius: 1,
    backgroundColor: "background.temporary",
    paddingX: [2, 2, 3]
  }, React.createElement(StrongText, {
    color: "feeling.temporary",
    fontWeight: 900,
    fontSize: [1, 1, 2]
  }, children));
};
TagOnlyLeft.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};
export const TagEndSales = _ref2 => {
  let {
    time,
    endIn
  } = _ref2;
  const {
    hh,
    mm,
    ss
  } = useTimer(time, {
    zeroFill: true
  });
  const isCounting = +hh || +mm || +ss;
  return isCounting ? React.createElement(Box, {
    borderRadius: 1,
    backgroundColor: "background.negative",
    paddingX: [2, 2, 3]
  }, React.createElement(StrongText, {
    color: "feeling.negative",
    fontWeight: 900,
    fontSize: [1, 1, 2]
  }, endIn, " ", hh, ":", mm, ":", ss)) : null;
};
TagEndSales.propTypes = process.env.NODE_ENV !== "production" ? {
  time: PropTypes.number.isRequired,
  endIn: PropTypes.string.isRequired
} : {};
export const TagPayAtDoor = _ref3 => {
  let {
    payAtDoor
  } = _ref3;
  return React.createElement(Box, {
    borderRadius: 1,
    backgroundColor: "background.positive",
    paddingX: [2, 2, 3]
  }, React.createElement(StrongText, {
    color: "feeling.positive",
    fontWeight: 900,
    fontSize: [1, 1, 2]
  }, payAtDoor));
};
TagPayAtDoor.propTypes = process.env.NODE_ENV !== "production" ? {
  payAtDoor: PropTypes.string.isRequired
} : {};